import { render, staticRenderFns } from "./hklogin.vue?vue&type=template&id=6518ad65&scoped=true&"
import script from "./hklogin.vue?vue&type=script&lang=js&"
export * from "./hklogin.vue?vue&type=script&lang=js&"
import style0 from "./hklogin.vue?vue&type=style&index=0&id=6518ad65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6518ad65",
  null
  
)

export default component.exports